<script setup lang="ts">
import { computed } from 'vue'
import { formatNumber } from '@nsftx/seven-nxg-retail-vue-sdk'

interface TicketCheckDetailsBetSummaryItemProps {
  text: string
  amount: string | number
  currency: string | undefined
}

const { text, amount, currency } = defineProps<TicketCheckDetailsBetSummaryItemProps>()

const formattedAmount = computed(() =>
  formatNumber(amount, {
    style: 'decimal'
  })
)
</script>

<template>
  <div
    class="st-ticket-check-details-bet-summary-item st-flex-between sc-mb-1 sc-px-5 sc-py-2 sc-text-primary-2"
  >
    <p>{{ text }}</p>
    <p>{{ formattedAmount }} {{ currency }}</p>
  </div>
</template>

<style lang="scss" scoped>
.st-ticket-check-details-bet-summary-item {
  background-color: #242628;
}
</style>
